import React, { useState, useEffect } from 'react';
import { Box, Typography, CircularProgress, Checkbox, useTheme } from '@mui/material';
import { StandardDialog } from 'shared-components/components';

interface PlanErrorProps {
  open: boolean;
  onClose: () => void;
  handleSubmit: () => void;
  loading: boolean;
}

const PlanError: React.FC<PlanErrorProps> = ({ open, onClose, handleSubmit, loading }) => {
  const [understood, setUnderstood] = useState(false);
  const theme = useTheme();

  const TOOLTIP_TEXT = 'Please acknowledge the disclaimer above before submitting the prescription change.';

  // Reset state when modal opens
  useEffect(() => {
    if (open) {
      setUnderstood(false);
    }
  }, [open]);

  const tooltipText = !understood ? TOOLTIP_TEXT : undefined;

  return (
    <StandardDialog
      title="Unable to retrieve RT plans"
      maxWidth="md"
      open={open}
      onClose={onClose}
      closeText="CANCEL"
      submitButtonProps={{
        disabled: loading || !understood,
        startIcon: loading ? <CircularProgress size={16} color="inherit" /> : undefined,
      }}
      submitButtonTooltip={tooltipText}
      submitText="SUBMIT CHANGES"
      onSubmit={() => {
        handleSubmit();
      }}>
      <Typography paddingY={2}>
        You're about to <strong>submit a prescription change</strong>, but the system couldn't verify if any active RT
        plans may be impacted due to a system or connectivity issue.
      </Typography>
      <Typography paddingY={2}>
        Please notify the appropriate team directly to prevent treatment from proceeding under outdated prescription
        details.
      </Typography>
      <Box sx={{ border: '1px solid grey', backgroundColor: theme.palette.grey[200], borderRadius: 1, p: 1 }}>
        <Box display="flex" alignItems="center" onClick={() => setUnderstood(!understood)} sx={{ cursor: 'pointer' }}>
          <Checkbox
            checked={understood}
            onChange={(e) => setUnderstood(e.target.checked)}
            onClick={(e) => e.stopPropagation()}
          />
          <Typography variant="body1">
            I understand that impacted RT plan(s) may <strong>remain "Treatment Approved"</strong> and I will notify the
            appropriate team directly to review them
            <span style={{ color: 'red' }}>*</span>
          </Typography>
        </Box>
      </Box>
    </StandardDialog>
  );
};

export default PlanError;
